import { FactorKey } from "types/factor/factor";

const displayNameMap = {
  [FactorKey.GoogleAuth]: "Google Authenticator",
  [FactorKey.OktaVerify]: "Okta Verify",
  [FactorKey.Sms]: "Phone-SMS",
  [FactorKey.Call]: "Phone-Voice call",
  [FactorKey.WebAuthn]: "Passkey",
};

export const GENERAL_ERROR =
  "Something went wrong. Please refresh the page and try again.";

export const addFactorMessage = (factorKey: FactorKey) =>
  `You have successfully added ${displayNameMap[factorKey]} as an MFA method.`;

export const removeFactorMessage = (factorKey: FactorKey) =>
  `You have successfully removed ${displayNameMap[factorKey]} as an MFA method.`;
